const social = require('./social');
import female_profs from "../assets/data/female_professionals.json"
import female_all from "../assets/data/female_all.json"
import female_managers from "../assets/data/female_managers.json"
import * as Pym from "pym.js";
import * as d3 from "d3";
import FemaleChart from "./FemaleChart.js";

//window.Pym = Pym;

var main = {
  init() {
    //social.init();
    main.drawChart();
    main.legendEvents(this.femaleChart);
    main.tabEvents(this.femaleChart);
    main.resizeEvents();
    main.embed();
  },
  amp() {
        window.parent.postMessage({
            sentinel: 'amp',
            type: 'embed-size',
            height: document.body.scrollHeight,
        }, '*');
    },
  // attach datasets to main object
  female_all: female_all,
  female_profs: female_profs,
  female_managers: female_managers,
  drawChart() {
    
      // set up female chart
    this.femaleChart = FemaleChart.create({
      "el": "#femaleChart",
      "valueType": "none",
      "data": main.female_profs,
      "colorHash": {
        'American_Indian_Alaskan_Native_female': "lightgray",
        'Black_or_African_American_female': "lightgray",
        'Latino_female': "lightgray",
        'Native_Hawaiian_or_Pacific_Islander_female': "lightgray",
        'Two_or_more_races_female': "lightgray",
        'Asian_female': "#737373",
        'White_female': "#222222",
        'Total_male': "ghostwhite"
      }
    });

    this.femaleChart.draw();
  },
  embed(){
    const pymChild = new Pym.Child({ polling: 100 });
  },
  legendEvents(chartVar) {
    const container = document.querySelector(chartVar.el)
      .parentNode;

    // listen to clicks on the main chart
    const buttons = container
      .querySelectorAll('.sortButton');

    Array.from(buttons).forEach(each => {
      const category = each.dataset.sort;
      each.addEventListener('click', () => {
        chartVar.sortOn(category);
      });
    });

  },
  resizeEvents(){

    const debouncedResize = _.debounce( function(){
      
      main.femaleChart.resize.bind(main.femaleChart)();
      main.amp();

    }, 250);

    window.addEventListener("resize", debouncedResize.bind(main));
  },
  tabEvents(chartVar) {
    // get container of the barchart, given its chart el
    const container = document.querySelector(chartVar.el)
      .parentNode;
    
    // get queryset of tabs in this container
    const tabs = container 
      .querySelector('.tabs').querySelectorAll("input");

    
    // iterate over every tab
    Array.from(tabs).forEach(each => {
      // get category name from tab data attr.
      const category = each.dataset.select;
      // add event listener to each tab 
      each.addEventListener('click', () => {
        // log the event
        console.log(`Changing dataset to ${category}`);
        // call the chart's changeData method
        // pass in the dataset as attached to main
        chartVar.changeData(main[category]);

      });
    });

  }
};

window.main = main;

// http://youmightnotneedjquery.com/ IE9+ loading
function ready(fn) {
  if (document.readyState != 'loading') {
    fn();
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
}

ready(main.init.bind(main));



// WEBPACK FOOTER //
// ./app/scripts/main.js